// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

export interface GeneratedAnalyticsMetadataFileInputClick {
  action: 'click';
  detail: {
    label: string;
  };
}

export interface GeneratedAnalyticsMetadataFileInputComponent {
  name: 'awsui.FileInput';
  label: string;
}
